<template>
    <PageWrapper>
        <template #headline>
            <fa icon="cart-shopping" />
            {{ $t('open_baskets') }}
        </template>

        <OpenBasketTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@partials/pages/PageWrapper.vue'
import OpenBasketTable from '@src/partials/orders/OpenBasketTable.vue'
</script>
